import { SurgicalScheduleModel } from 'domain/entities/surgical-schedule-model'

export enum AnesthetistType {
  CHOOSE_ANESTHESTIST = 'choose-anesthetist',
  SCALE = 'scale',
  LOCAL = 'local-anesthesia'
}

export type ScheduleRequest = {
  scheduleRequest: SurgicalScheduleModel
}

export type ModalDetails = {
  scheduleRequest: SurgicalScheduleModel
  setShowModalDetails: any
  showModalDetails: any
}

export type PropsEquipamentsModel = {
  scheduleRequest: SurgicalScheduleModel
  setShowModalEquipments: any
  showModalEquipments: any
}

export const optionsTime = [
  { label: '00h30', value: '00:30' },
  { label: '01h00', value: '01:00' },
  { label: '01h30', value: '01:30' },
  { label: '02h00', value: '02:00' },
  { label: '02h30', value: '02:30' },
  { label: '03h00', value: '03:00' },
  { label: '03h30', value: '03:30' },
  { label: '04h00', value: '04:00' },
  { label: '04h30', value: '04:30' },
  { label: '05h00', value: '05:00' },
  { label: '05h30', value: '05:30' },
  { label: '06h00', value: '06:00' },
  { label: '06h30', value: '06:30' },
  { label: '07h00', value: '07:00' },
  { label: '07h30', value: '07:30' },
  { label: '08h00', value: '08:00' },
  { label: '08h30', value: '08:30' },
  { label: '09h00', value: '09:00' },
  { label: '09h30', value: '09:30' },
  { label: '10h00', value: '10:00' },
  { label: '10h30', value: '10:30' },
  { label: '11h00', value: '11:00' },
  { label: '11h30', value: '11:30' },
  { label: '12h00', value: '12:00' },
  { label: '12h30', value: '12:30' },
  { label: '13h00', value: '13:00' },
  { label: '13h30', value: '13:30' },
  { label: '14h00', value: '14:00' },
  { label: '14h30', value: '14:30' },
  { label: '15h00', value: '15:00' },
  { label: '15h30', value: '15:30' },
  { label: '16h00', value: '16:00' },
  { label: '16h30', value: '16:30' },
  { label: '17h00', value: '17:00' },
  { label: '17h30', value: '17:30' },
  { label: '18h00', value: '18:00' },
  { label: '18h30', value: '18:30' },
  { label: '19h00', value: '19:00' },
  { label: '19h30', value: '19:30' },
  { label: '20h00', value: '20:00' },
  { label: '20h30', value: '20:30' },
  { label: '21h00', value: '21:00' },
  { label: '21h30', value: '21:30' },
  { label: '22h00', value: '22:00' },
  { label: '22h30', value: '22:30' },
  { label: '23h00', value: '23:00' },
  { label: '23h30', value: '23:30' }
]
